import * as React from "react";
import { SVGProps } from "react";

const Metadium = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 628 308" {...props}>
    <path
      fill="#231f20"
      d="M99.3 14.2v70.9a14.19 14.19 0 0 1-14.2 14.2H14.2A14.19 14.19 0 0 1 0 85.1V14.2A14.19 14.19 0 0 1 14.2 0h70.9a14.19 14.19 0 0 1 14.2 14.2Zm98.6 95.1H127a14.19 14.19 0 0 0-14.2 14.2v170.6a14.19 14.19 0 0 0 14.2 14.2h70.9a14.19 14.19 0 0 0 14.2-14.2V123.5a14.19 14.19 0 0 0-14.2-14.2Zm211.2 0h-53.5a38.09 38.09 0 0 1-38.1-38.1v-57A14.19 14.19 0 0 0 303.3 0h-70.9a14.19 14.19 0 0 0-14.2 14.2v70.9a14.19 14.19 0 0 0 14.2 14.2h26a31.08 31.08 0 0 1 4.3-.3h23.2a38.09 38.09 0 0 1 38.1 38.1V294a14.19 14.19 0 0 0 14.2 14.2h70.9a14.19 14.19 0 0 0 14.2-14.2V123.5a14.19 14.19 0 0 0-14.2-14.2Zm205.3 0h-53.5a38.09 38.09 0 0 1-38.1-38.1v-57A14.19 14.19 0 0 0 508.6 0h-71a14.19 14.19 0 0 0-14.2 14.2v70.9a14.19 14.19 0 0 0 14.2 14.2h26a31.08 31.08 0 0 1 4.3-.3h23.2a38.09 38.09 0 0 1 38.1 38.1V294a14.19 14.19 0 0 0 14.2 14.2h70.9a14.19 14.19 0 0 0 14.2-14.2V123.5a14 14 0 0 0-14.1-14.2Z"
    />
  </svg>
);

export default Metadium;
